import { z } from 'zod'

export const healthLiveSchema = z.object({
  status: z.literal('ok'),
  service: z.string().min(1),
  checked_at: z.string().min(1),
})

export const healthReadySchema = z.object({
  status: z.enum(['ok', 'degraded']),
  service: z.string().min(1),
  checks: z.record(z.string(), z.string()),
  checked_at: z.string().min(1),
})

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
})

export type HealthLive = z.infer<typeof healthLiveSchema>
export type HealthReady = z.infer<typeof healthReadySchema>
export type ApiErrorBody = z.infer<typeof apiErrorSchema>
